import React, { Component } from 'react';
import SignUpForm from './sign-up/SignUpForm';
import fetchDux from '../../state/fetch-dux';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import MetaTags from 'react-meta-tags';

import Layout from '../ui/Layout';
import MetaLoader from '../ui/MetaLoader';
import queryString from 'query-string';

class SignUpRoute extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchAddress: true,
      searchValue: '',
      address1: ''
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.getLookups();
    this.props.clearPostSignUp();
    document.body.classList.add(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-signup',
      'page-template-page-templatesshop-signup-php',
      'page',
      'page-id-243',
      'page-child',
      'parent-pageid-212',
      'no-sidebar'
    );
  }
  componentWillUnmount() {
    this.props.clearPostSignUp();
    document.body.classList.remove(
      'page-template',
      'page-template-page-templates',
      'page-template-shop-signup',
      'page-template-page-templatesshop-signup-php',
      'page',
      'page-id-243',
      'page-child',
      'parent-pageid-212',
      'no-sidebar'
    );
  }
  render() {
    const {
      postSignUp,
      // duplicate
      error,
      lookups,
      postSignUpResult,
      location: { search },
      getAddressSuggestions,
      getAddressSuggestionsResult,
    } = this.props;
    const { waitlist } = queryString.parse(search);
    const { searchAddress, searchValue } = this.state;

    const scrollToTop = () => window.scrollTo(0, 0);
    const handlePostSignUp = values => {
      if (waitlist) values = { ...values, waitlist };
      postSignUp(values, 'sign-up-form', null, () => scrollToTop());
    };

    const handleGetAddressSuggestions = async (value) => {
      this.setState({ searchValue: value });
      if ((value || []).length > 2) {
        await getAddressSuggestions({ searchText: value });
      }
    };
    const handleSelect = ({ address1, searchAddress }) => {
      this.setState({ address1: address1, searchAddress: searchAddress });
    }

    const { ok: signupComplete, ClubName } = postSignUpResult || {};
    return (
      <Layout>
        <MetaLoader title="Create Account | Twomey" />
        <MetaTags>
          <title>Create Account | Twomey</title>
          <meta property="og:site_name" content="Twomey.com" />
          <meta property="og:title" content="Create Account | Twomey" />
          <meta property="og:type" content="article" />
          <meta
            property="og:url"
            content="https://twomey.com/account/sign-up"
          />
        </MetaTags>

        <div id="content" className="site-content">
          <div id="primary" className="content-area">
            <main
              id="main"
              className="site-main shop-page nohero extra cart-page"
            >
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-md-10">

                    {signupComplete &&
                      <div>
                        <h1 className="smaller">Please Check Your Email</h1>
                        <p>
                          {
                            waitlist ?
                              `Almost done! We have received your request to join ${ClubName} membership waitlist. Please check your inbox for a link to verify your email address,
                              before you can log in to your account.`
                              :
                              `Almost done! Please check your inbox for a link to verify your email address, before you can log in to your account.`
                          }

                        </p>
                      </div>}
                    {!signupComplete &&
                      <div>
                        <h1 className="shop-large">Sign Up</h1>
                        <div className="row">
                          <div className="col-md-6 lighter-text">
                            <p>
                              We respect your privacy and will not share any of your personal information.
                            </p>
                            <br />
                          </div>
                        </div>
                        <SignUpForm
                          onSubmit={handlePostSignUp}
                          signupError={error}
                          lookups={lookups}
                          handleSelect={handleSelect}
                          searchValue={searchValue}
                          searchAddress={searchAddress}
                          getAddressSuggestionsResult={getAddressSuggestionsResult}
                          handleGetAddressSuggestions={handleGetAddressSuggestions}
                        />
                      </div>}

                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>

        <div className="container text-right">
          <div className="row justify-content-center">
            <div className="col-md-10 text-right">
              <a href="#" className="back-to-top" onClick={scrollToTop}>
                Back to top
              </a>
            </div>
          </div>
        </div>

      </Layout>
    );
  }
}

const mapState = state => {
  const {
    error,
    result: postSignUpResult
  } = state.postSignUp.toJS();
  const {
    result: getAddressSuggestionsResult
  } = state.getAddressSuggestions.toJS();
  const {
    // error,
    inProgress: lookupsInProgress,
    result: lookups
  } = state.getLookups.toJS();

  return {
    error,
    lookups,
    postSignUpResult,
    getAddressSuggestionsResult
  };
};

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      postSignUp: fetchDux.postSignUp.createAction,
      clearPostSignUp: fetchDux.postSignUp.clearAction,
      getLookups: fetchDux.getLookups.createAction,
      getAddressSuggestions: fetchDux.getAddressSuggestions.createAction,
      clearGetAddressSuggestions: fetchDux.getAddressSuggestions.clearAction,
    },
    dispatch
  );
export default connect(mapState, mapDispatch)(SignUpRoute);
